<template>
  <div id="app">
    <router-view />
    <div class="app-version-watermark">v1.0.022</div>
  </div>
</template>
<script>

export default {
  name: 'App',
  components: {

  },
  mounted(){
    // if (localStorage.getItem('rg') != '406') {
    //   this.$router.push('/login');
    // } else {
    //this.$router.push('/app-register')
    // }
  }
}
</script>
<style lang="scss">
#app {
  width: 100%;
  height: 100%;
}
body {
  margin: 0;
  padding: 0;
}
/* 版本号水印：固定右下角，始终置顶，不遮挡点击 */
.app-version-watermark {
  position: fixed;
  bottom: 8px;
  right: 12px;
  z-index: 99999;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.25);
  pointer-events: none;
  user-select: none;
  font-family: inherit;
  text-shadow: 1px 1px white;
}
</style>
